import React, { useMemo } from "react";
import { StyledCheck } from "./StyledCheck";
import CheckIcon from "./CheckIcon";
import StyledText from "../StyledText";
import { CorporateTheme } from "../../../utils/themes";
import { useTheme } from "../../../middleware/ThemeContext";

interface StyledCheckBoxProps {
  value: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  size?: number;
  labelSize?: string;
  className?: string;
  labelClassName?: string;
  color?: string;
  borderColor?: string;
  bgColor?: string;
  checkColor?: string;
  isShowAccessKey?: boolean;
  accessKey?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const StyledCheckBox: React.FC<StyledCheckBoxProps> = ({
  value,
  onChange,
  label,
  children,
  disabled,
  size,
  checkColor = '#fff',
  borderColor,
  bgColor,
  color,
  isShowAccessKey = false,
  accessKey,
  onClick,
  ...props
}) => {
  const { theme } = useTheme();
  const id = useMemo(() => `checkbox-${Math.random()}`, []);

  const onChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <label
        htmlFor={id}
        className={`d-flex align-items-center mb-0 me-1 w-100 ${props?.className ?? ""
          }`}
        style={{ cursor: "pointer", fontSize: props.labelSize, opacity: disabled ? '0.5' : '1' }}
      >
        <StyledCheck
          borderColor={borderColor}
          bgColor={value ? bgColor : ""}
          value={value}
          size={size}
          onClick={onClick}
          {...props}
        >
          {value && (
            <CheckIcon
              style={{ color: checkColor }}
              size="8px"
            />
          )}
        </StyledCheck>

        {(children || label) && (
          < div className="w-100">
            {children ? (
              <div className={`ms-2 ${props?.labelClassName ?? ''}`}>{children}</div>
            ) : (
              <StyledText
                fontSize="14px"
                fontWeight={500}
                textColor={color || theme.CorporateTheme?.colors?.textSecondary}
                className={`ms-2 text-nowrap ${props?.labelClassName}`}
              >
                {label}
              </StyledText>
            )}

            {(isShowAccessKey && accessKey) && (
              <StyledText
                fontSize="12px"
                fontWeight={500}
                textColor={theme.CorporateTheme?.colors?.textSecondary}
                className={`ms-2 mt-1 text-nowrap ${props?.labelClassName}`}
              >
                {accessKey}
              </StyledText>
            )}
          </div>
        )}

      </label>

      <input
        id={id}
        type="checkbox"
        style={{ display: "none" }}
        checked={value ?? false}
        disabled={disabled}
        onChange={onChangeCheckbox}
        onClick={onClick}
      />
    </>
  );
};

export default StyledCheckBox;
